import React from 'react';

import SVGIcon from 'src/components/svg';

import { lang } from 'src/helpers';

import model from './model';

export const Continue = React.memo(({hide, item, router}) => {
  const click = (action) => {
    const contact = item.partner;
    hide();
    model.emit('onOpenDoctorMessages', contact);
    router.navigate('/messages/' + contact.id);
    switch (action) {
      case 'call':
        model.emit('startCall',
          {video: false, partner: contact});
        break;
      case 'chat':
        break;
      case 'video':
        model.emit('startCall',
          {video: true, partner: contact});
        break;
    }
  };

  return (
    <div className="mc-flex-30">
      <button
        className={'mc-flex-10-col mc-flex-center mc-no-style-btn'}
        onClick={() => click('call')}
      >
        <SVGIcon iconname="modal-call-icon"/>
        <div className={'mc-value-518'}>{lang.t('Call')}</div>
      </button>
      <button
        className={'mc-flex-10-col mc-flex-center mc-no-style-btn'}
        onClick={() => click('chat')}
      >
        <SVGIcon iconname="modal-chat-icon"/>
        <div className={'mc-value-518'}>{lang.t('Chat')}</div>
      </button>
      <button
        className={'mc-flex-10-col mc-flex-center mc-no-style-btn'}
        onClick={() => click('video')}
      >
        <SVGIcon iconname="modal-video-icon"/>
        <div className={'mc-value-518'}>{lang.t('Video')}</div>
      </button>
    </div>
  );
});
Continue.displayName = 'Continue';